import { Box, Divider, Typography } from "@mui/material";

export interface PageHeaderProps {
  title: string;
  icon?: React.ReactNode;
  rightContent?: React.ReactNode;
  /**
   * On extra-small viewports, render `rightContent` below the title row at full width so dense toolbars
   * do not squeeze beside the title.
   */
  stackToolbarOnMobile?: boolean;
}

export const PageHeader = ({ title, icon, rightContent, stackToolbarOnMobile = false }: PageHeaderProps) => {
  return (
    <Box>
      <Box
        sx={{
          alignItems: stackToolbarOnMobile ? { sm: "center", xs: "stretch" } : "center",
          display: "flex",
          flexDirection: stackToolbarOnMobile ? { sm: "row", xs: "column" } : "row",
          gap: stackToolbarOnMobile ? { sm: 2, xs: 1.5 } : { sm: 2, xs: 1 },
          justifyContent: "space-between",
          mb: 2,
          rowGap: stackToolbarOnMobile ? 1.5 : undefined,
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            gap: { sm: 2, xs: 1 },
            minWidth: 0,
            width: stackToolbarOnMobile ? { sm: "auto", xs: "100%" } : undefined,
          }}
        >
          {icon ? <Box sx={{ alignItems: "center", display: "flex", flexShrink: 0, lineHeight: 0 }}>{icon}</Box> : null}
          <Typography component="h1" sx={{ minWidth: 0 }} variant="page-header">
            {title}
          </Typography>
        </Box>
        {rightContent ? (
          <Box
            sx={{
              alignSelf: stackToolbarOnMobile ? { sm: "auto", xs: "stretch" } : undefined,
              flex: stackToolbarOnMobile ? { sm: 1 } : undefined,
              minWidth: 0,
              width: stackToolbarOnMobile ? { sm: "auto", xs: "100%" } : undefined,
            }}
          >
            {rightContent}
          </Box>
        ) : null}
      </Box>
      <Divider />
    </Box>
  );
};
